import { combineReducers } from 'redux';

import app from 'js/store/app/App.reducer';
import characters from 'js/store/characters/Characters.reducer';
import locations from 'js/store/locations/Locations.reducer';
import makes from 'js/store/makes/Makes.reducer';
import games from 'js/store/games/Games.reducer';
import videos from 'js/store/videos/Videos.reducer';
import contentFilter from 'js/store/content-filter/ContentFilter.reducer';
import pageTemplates from 'js/store/page-templates/PageTemplates.reducer';
import gallery from 'js/store/gallery/Gallery.reducer';
import youtube from 'js/store/youtube/Youtube.reducer';

const RootReducer = combineReducers({
  app,
  characters,
  locations,
  makes,
  games,
  videos,
  contentFilter,
  pageTemplates,
  gallery,
  youtube,
});

export default RootReducer;
